import { api } from "@/api/client";
import type { components } from "@/api/schema.gen";

export type ShellReconMeResponse = components["schemas"]["MeOut"];

export const RECON_ME_QUERY_KEY = ["recon", "me"] as const;

export function getReconMe(
  opts?: { signal?: AbortSignal },
): Promise<ShellReconMeResponse> {
  return api.get<ShellReconMeResponse>("/api/recon/me", { signal: opts?.signal });
}
